import { Toaster } from "sonner";
import "./toaster.css";

const ToasterComponent: React.FC = () => {
  return (
    <Toaster
      richColors
      toastOptions={{
        classNames: {
          info: "info-toast",
          error: "error-toast",
        },
        style: {
          whiteSpace: "pre-line",
        },
      }}
    />
  );
};

export default ToasterComponent;
